<template>
  <mtd-menu
    ref="accountMenuRef"
    model-value="1"
    mode="horizontal"
    class="login-menu"
    @select="handleSelect"
  >
    <mtd-submenu name="2" class="account" popper-class="custom-popper">
      <template #title>
        <span class="login-name">{{ $xxPlatform.accountInfo && $xxPlatform.accountInfo.login }}</span>
      </template>
      <!-- 账户类型为“商户账户&劳动力商户”时展示平台切换选项 -->
      <mtd-menu-item v-if="+$xxPlatform.accountInfo.accountType === 2" name="nav">
        {{ toggleAccountLabel }}
      </mtd-menu-item>
      <mtd-menu-item name="updatePassport">
        {{
          $getText("b_fe_vss__passwords_modifying_BSM6", {
            defaultValue: "Change Password",
            originValue: "修改密码",
          })
        }}</mtd-menu-item
      >
      <mtd-menu-item name="updatePhone">
        {{
          $getText("b_fe_vss__Cell_phones_Tkru", {
            defaultValue: "Change the bound mobile phone",
            originValue: "换绑手机",
          })
        }}
      </mtd-menu-item>
      <mtd-menu-item name="updateEmail">
        {{
          $getText("b_fe_vss_Mail_0AD5", {
            defaultValue: "Change Email Address",
            originValue: "换绑邮箱",
          })
        }}
      </mtd-menu-item>
      <!-- <mtd-menu-item name="clear"> 清除缓存 </mtd-menu-item> -->
      <mtd-menu-item name="logout">
        {{
          $getText("b_fe_vss__Quit_QGic", {
            defaultValue: "Exit",
            originValue: "退出",
          })
        }}</mtd-menu-item
      >
    </mtd-submenu>
  </mtd-menu>
</template>

<script>
import {
  getBindphoneUrl,
  getResetPasswordUrl,
  getBindEmailUrl,
} from "@/utils/epassport.js";
import { linkTo, hPost } from "@osgfe/tools";
import { ACCOUNT_TYPE } from "../../../../constants/index";
import { clearStorage } from "@osgfe/tools-storage";

export default {
  name: "AccountMenu",
  inject: ['$xxPlatform'],
  props: {
    toggleAccount: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      accountMenuRef: null,
    };
  },
  computed: {
    toggleAccountLabel() {
      const code = this.toggleAccount ? this.toggleAccount.code : null;
      const label = this.toggleAccount ? this.toggleAccount.label : null;
      if (code === ACCOUNT_TYPE.RENXIAO) {
        return this.$getText("b_fe_vss__Switching_Labor_Fgrn", {
          defaultValue: "Switch to Workforce Collaboration Platform",
          originValue: "切换到" + label,
        });
      }
      return this.$getText("b_fe_vender_pc_vss_Switching_merchandise_ZFgC", {
        defaultValue: "",
        originValue: "切换到" + label,
      });
    },
  },
  methods: {
    toggleFold() {
      if (document.querySelector(".m-aside"))
        document.querySelector(".m-aside").style.display = "block";
    },
    nav() {
      if (this.toggleAccount && this.toggleAccount.to) {
        window.top.location.href = this.toggleAccount.to;
      }
    },
    updatePassport() {
      linkTo(getResetPasswordUrl(), {}, { isNewTab: true });
    },
    updatePhone() {
      linkTo(getBindphoneUrl(), {}, { isNewTab: true });
    },
    updateEmail() {
      linkTo(getBindEmailUrl(), {}, { isNewTab: true });
    },
    clear() {
      clearStorage();
      this.$message.success("清除缓存成功");
    },
    // 退出登录
    // 【测试环境webstatic未建设epassport的欧洲机房环境导致登陆问题，故使用keemart接口绕过webstatic】
    async logout() {
      // 原来的方式（保留，暂不删除）
      // epassportLogout();
      try {
        await hPost("/api/vss/shepherd/supplier/logout");
        window.location.href = `${window.location.origin}/login.html`;
      } catch (e) {
        this.$message.error(e?.message || e?.msg);
      }
    },
    handleSelect(menuItem) {
      if (menuItem.name === "nav") this.nav();
      if (menuItem.name === "updatePassport") this.updatePassport();
      if (menuItem.name === "updatePhone") this.updatePhone();
      if (menuItem.name === "updateEmail") this.updateEmail();
      if (menuItem.name === "clear") this.clear();
      if (menuItem.name === "logout") this.logout();
    },
  },
};
</script>

<style lang="scss" scoped>
.login-name {
  color: #111925;
  margin-inline-end: 4px;
}

/* .login-name:hover {
  color: rgba(255, 255, 255, 0.75);
  background-color: #01a65c !important;
} */
/* .login-menu {
  background: #01a65c;
} */
.login-menu :deep(.mtd-submenu-title) {
  padding: 0;
}

:deep() .mtdicon.mtdicon-down-thick.mtd-submenu-direction {
  font-size: 18px;
  vertical-align: middle;
}
:deep() .mtdicon.mtdicon-down-thick.mtd-submenu-direction:hover {
  font-size: 18px;
}
:deep() .mtd-submenu-title:hover .mtd-submenu-direction {
  color: #00b85c !important;
}
</style>

<style lang="scss">
:deep() .mtd-submenu-dropdown {
  width: 320px !important;
}

.custom-popper {
  width: 306px !important;
}
</style>